const LOGOS: ReadonlyArray<{ label: string; className: string }> = [
  { label: 'LINEAR', className: 'font-display font-bold text-xl tracking-tighter' },
  { label: 'stripe', className: 'font-display font-semibold text-xl text-ink-muted' },
  { label: 'Figma', className: 'font-sans italic font-bold text-xl lowercase' },
  { label: 'VERCEL', className: 'font-display font-extrabold text-xl uppercase tracking-widest' },
  { label: 'Notion', className: 'font-editorial font-semibold text-xl' },
];

export function TrustStrip() {
  return (
    <section className="border-y border-line bg-board py-12">
      <div className="mx-auto max-w-container px-6 text-center">
        <p className="mb-8 text-xs font-semibold uppercase tracking-widest text-ink-faint">
          not used by anyone at these companies (yet)
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8 opacity-60 grayscale transition-all duration-500 hover:grayscale-0">
          {LOGOS.map((logo) => (
            <span key={logo.label} className={logo.className}>
              {logo.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
